import documentosAPI, {
  DocumentoRequestUpdate,
  DocumentoRequestUpload,
} from 'api/Assessor/documentos';
import duvidasApi, {
  MensagensFiltros,
  PaginationDuvidas,
} from 'api/Assessor/duvidas';
import eventoApi, {
  AcompanharVotacao,
  PresencasResponse,
} from 'api/Assessor/evento';
import { ErrorAPI } from 'api/Assessor/methods';
import { PautaEvento } from 'api/Assessor/pautas';
import quorumApi from 'api/Assessor/quorum';
import relatorioApi from 'api/Assessor/relatorios';
import usuarioApi, {
  CooperativasUsuarioResponse,
  ListagemLoginsRequest,
  ListagemLoginsResponse,
} from 'api/Assessor/usuario';
import videoAPI, { BatchVideoRequest, VideoRequest } from 'api/Assessor/video';
import { ErrorApi } from 'api/interfaces';
import { AxiosError, AxiosResponse } from 'axios';
import { AssembleiaPautaStatus } from 'helpers/enums/AssembleiaPautaStatus';
import { AssembleiaStatus } from 'helpers/enums/AssembleiaStatus';
import { getPautaAssessorWithOrderedOptions } from 'helpers/utils/AssembleiaUtils';
import trigger from 'helpers/utils/DownloadTrigger';
import { toRequest } from 'helpers/utils/RequestUtils';
import {
  getAssembleiasAssessorBffEndpoint,
  getAssembleiasAssessorEndpoint,
} from 'library/Apis';
import moment from 'moment';
import { Action, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import ApiService from 'services/ApiService';
import { IReducer } from 'store/Reducer';
import {
  AssembleiasAssessorActionTypes,
  ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA,
  ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT,
  ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS,
  ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE,
  ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA,
  ASSEMBLEIAS_ASSESSOR_CLEARED_EVENTO,
  ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA,
  ASSEMBLEIAS_ASSESSOR_EDITED,
  ASSEMBLEIAS_ASSESSOR_LOADED_AGENCIAS_NUCLEOS_SEM_VOTO,
  ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_NUCLEOS_SEM_VOTO,
  ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
  ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS,
  ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO,
  ASSEMBLEIAS_ASSESSOR_LOADING_EVENT_ATTACHMENT,
  ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO,
  ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
  ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS_PRESENCIAL,
  ASSEMBLEIAS_ASSESSOR_LOADING_VOTOS_INCONSISTENTES,
  ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS,
  ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS,
  ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO,
  ASSEMBLEIAS_ASSESSOR_LOAD_EVENT_ATTACHMENT,
  ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO,
  ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS,
  ASSEMBLEIAS_ASSESSOR_LOAD_VOTOS_INCONSISTENTES,
  ASSEMBLEIAS_ASSESSOR_REFRESH,
  ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA,
  ASSEMBLEIAS_ASSESSOR_UPDATE_QUORUM,
  ASSEMBLEIAS_ASSESSOR_UPDATE_VOTATION,
  IAssembleiasAssessorDeleteCurrentEvent,
  IAssembleiasAssessorRefresh,
} from './AssembleiasAssessorActionTypes';
import {
  AssembleiaAssessorDadosInformativos,
  IAssembleiaAssessorAgenciaNucleosSemVoto,
  IAssembleiaAssessorLoadContas,
  IAssembleiasAssessorDocumentos,
  IAssembleiasAssessoresRegistrarPresenca,
  IAssembleiasAssessorEvent,
  IAssembleiasAssessorEventList,
  IAssembleiasAssessorPauta,
  ICadastrarPautaRequest,
  ICadastrarPautaRequest2,
  IRequestPautasRespostas,
  IVotosInconsistentes,
} from './AssembleiasAssessorReducer';
import { IWSAssembleia } from './WSAssembleiasReducer';

type ThunkActionDefault = ThunkAction<Promise<void>, IReducer, undefined, any>;

export const assembleiaAssessorActionsRefresh = (
  assembleia: IWSAssembleia
): IAssembleiasAssessorRefresh => {
  return {
    type: ASSEMBLEIAS_ASSESSOR_REFRESH,
    payload: assembleia,
  };
};

interface DeleteProps {
  eventId: number;
  agendaIds: number[];
}

export const assembleiaAssessorActionsClearedEvento = () => {
  return {
    type: ASSEMBLEIAS_ASSESSOR_CLEARED_EVENTO,
  };
};

export const assembleiasAssessorLoadEvento = (
  idEvento: number,
  callbackSuccess?: (all: IAssembleiasAssessorEvent) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO,
      payload: true,
    });
    toRequest(
      ApiService.get,
      [`${getAssembleiasAssessorEndpoint('1')}evento/${idEvento}`],
      'assembleiaAssessorLodEvent'
    )
      .then((resp) => {
        const data: IAssembleiasAssessorEvent =
          resp.data as IAssembleiasAssessorEvent;
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO,
          payload: data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(data);
        }
      })
      .catch((error: AxiosError<ErrorAPI>) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      })
      .finally(() => {
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO,
          payload: false,
        });
      });
  };
};

export const assembleiasAssessorLoadEventAttachment = (
  eventId: number,
  callbackSuccess?: (all: IAssembleiasAssessorDocumentos[]) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_EVENT_ATTACHMENT,
      payload: true,
    });
    toRequest(
      ApiService.get,
      [`${getAssembleiasAssessorBffEndpoint('1')}attachment/${eventId}`],
      'assembleiaAssessorLoadEventAttach'
    )
      .then((resp) => {
        const data: IAssembleiasAssessorDocumentos[] =
          resp.data as IAssembleiasAssessorDocumentos[];
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_LOAD_EVENT_ATTACHMENT,
          payload: data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(data);
        }
      })
      .catch((error: AxiosError<ErrorAPI>) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      })
      .finally(() => {
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_LOADING_EVENT_ATTACHMENT,
          payload: false,
        });
      });
  };
};

export const assembleiasAssessorActionsLoadEventoList = (
  callbackSuccess?: (eventList: IAssembleiasAssessorEventList[]) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO,
      payload: true,
    });
    new Promise(
      (
        resolve: (eventList: IAssembleiasAssessorEventList[]) => void,
        reject: (error: AxiosError<ErrorAPI>) => void
      ) => {
        toRequest(
          ApiService.get,
          [`${getAssembleiasAssessorEndpoint('1')}evento/lista`],
          'assembleiaAssessorLodEventList'
        ).then(
          (resp) => {
            const data: IAssembleiasAssessorEventList[] =
              resp.data as IAssembleiasAssessorEventList[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO,
              payload: false,
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO,
              payload: false,
            });
            reject(error);
          }
        );
      }
    ).then(
      (eventList) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(eventList);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssessorMakeAvailableEvent = (
  eventId: number,
  callbackSuccess?: () => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_EVENT_ATTACHMENT,
      payload: true,
    });
    toRequest(
      ApiService.post,
      [
        `${getAssembleiasAssessorBffEndpoint(
          '1'
        )}event/make-available?eventId=${eventId}`,
      ],
      'assembleiasAssessorMakeAvailableEvent'
    )
      .then(() => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      })
      .catch((error: AxiosError<ErrorAPI>) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      })
      .finally(() => {
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_LOADING_EVENT_ATTACHMENT,
          payload: false,
        });
      });
  };
};

export const assembleiasAssessorActionsAlterarSituacaoPauta = (
  idEvento: number,
  idPauta: number,
  durationByPeriod: string | null,
  durationByTime: number | null,
  status: AssembleiaPautaStatus,
  callbackSuccess?: Function,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise(
      (resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
        toRequest(
          ApiService.put,
          [
            `${getAssembleiasAssessorEndpoint('1')}pauta/status`,
            {
              idEvento,
              idPauta,
              durationByPeriod,
              durationByTime,
              status,
            },
          ],
          'save'
        ).then(
          () => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA,
            });
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        );
      }
    ).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssessorActionsAlterarSituacaoPautaPresencial = (
  idEvento: number,
  idPauta: number,
  tempo: number,
  status: AssembleiaPautaStatus,
  callbackSuccess?: Function,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    new Promise(
      (resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
        toRequest(
          ApiService.put,
          [
            `${getAssembleiasAssessorEndpoint('1')}pauta/status-presencial`,
            {
              idEvento,
              idPauta,
              tempo,
              status,
            },
          ],
          'save'
        ).then(
          () => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA,
            });
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        );
      }
    ).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssessorActionsAlterarSituacaoPautaPorDataETempo = (
  durationByPeriod: string | null,
  durationByTime: number | string | null,
  idEvento: number,
  pautas: any,
  callbackSuccess?: Function,
  callBackClose?: Function,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return () => {
    new Promise(
      (resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
        toRequest(
          ApiService.post,
          [
            `${getAssembleiasAssessorEndpoint('1')}pauta/liberar-votacao`,
            {
              durationByPeriod,
              durationByTime,
              idEvento,
              pautas,
            },
          ],
          'save'
        ).then(
          () => {
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        );
      }
    ).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
        if (typeof callBackClose === 'function') {
          callBackClose();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssessorActionsLiberarVotacaoPresencial = (
  idEvento?: number,
  callbackSuccess?: Function,
  callBackClose?: Function,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return () => {
    new Promise(
      (resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
        toRequest(
          ApiService.post,
          [
            `${getAssembleiasAssessorEndpoint(
              '1'
            )}pauta/liberar-votacao-presencial?idEvento=${idEvento}`,
          ],
          ''
        ).then(
          () => {
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        );
      }
    ).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
        if (typeof callBackClose === 'function') {
          callBackClose();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiaAssessorAcompanhamentoParcial = (
  idPauta: number,
  callbackSuccess?: (resultado: AcompanharVotacao) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionDefault => {
  return async () => {
    const { fail, data } = await eventoApi.acompanharVotacao(idPauta);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
  };
};

export const parametroAssessorResultadoPadrao = (
  codCoop: string,
  callbackSuccess?: (resultado: AcompanharVotacao) => void,
  callbackError?: (error: ErrorApi) => void
): ThunkActionDefault => {
  return async () => {
    const { fail, data } = await eventoApi.respostaPadrao(codCoop);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
  };
};

export const assembleiasAssessorActionsAlterarSituacaoAssembleia = (
  assembleiaId: number,
  status: AssembleiaStatus,
  callbackSuccess?: Function,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return () => {
    new Promise(
      (resolve: Function, reject: (error: AxiosError<ErrorAPI>) => void) => {
        toRequest(
          ApiService.put,
          [
            `${getAssembleiasAssessorEndpoint('1')}evento/status`,
            {
              idEvento: assembleiaId,
              status: status,
            },
          ],
          'assembleiaAssessorLodPautas'
        ).then(
          () => {
            resolve();
          },
          (error: AxiosError<ErrorAPI>) => {
            reject(error);
          }
        );
      }
    ).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssessorActionsLoadPautas = (
  assembleiaId: number,
  callbackSuccess?: (pautas: IAssembleiasAssessorPauta[]) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
      payload: true,
    });
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS_PRESENCIAL,
      payload: true,
    });
    new Promise(
      (
        resolve: (pautas: IAssembleiasAssessorPauta[]) => void,
        reject: (error: AxiosError<ErrorAPI>) => void
      ) => {
        toRequest(
          ApiService.get,
          [
            `${getAssembleiasAssessorEndpoint(
              '1'
            )}pauta/pautas-evento?idEvento=${assembleiaId}`,
          ],
          'assembleiaAssessorLodPautas'
        ).then(
          (resp) => {
            const pautas: IAssembleiasAssessorPauta[] =
              resp.data as IAssembleiasAssessorPauta[];
            const data: IAssembleiasAssessorPauta[] = pautas.map(
              (pauta: IAssembleiasAssessorPauta): IAssembleiasAssessorPauta => {
                return getPautaAssessorWithOrderedOptions(pauta);
              }
            );
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS,
              assembleiaId,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
              payload: false,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS_PRESENCIAL,
              payload: false,
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
              payload: false,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS_PRESENCIAL,
              payload: false,
            });
            reject(error);
          }
        );
      }
    ).then(
      (pautas) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(pautas);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export function assembleiasAssessorActionsDeleteCurrentEvent(): IAssembleiasAssessorDeleteCurrentEvent {
  return {
    type: ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT,
    payload: undefined,
  };
}

export type ThunkDownloadDocumentAssessorReturn = ThunkAction<
  Promise<void>,
  IReducer,
  undefined,
  Action
>;

export function assembleiaAssessorActionsDownloadDocument(
  idDocument: number,
  fileName: string,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkDownloadDocumentAssessorReturn {
  return async (dispatch, getState) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE,
      payload: [
        ...getState().assembleiasAssessor.downloadindDocument,
        idDocument,
      ],
    });
    const { fail, data: file } = await documentosAPI.download(idDocument);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (file) {
      trigger(fileName, file);
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS,
        payload: [
          ...getState().assembleiasAssessor.downloadSuccessfully,
          idDocument,
        ],
      });
      successCallback && successCallback();
    }
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE,
      payload: getState().assembleiasAssessor.downloadindDocument.filter(
        (id) => id !== idDocument
      ),
    });
  };
}

export function assembleiaAssessorActionsUpdateDocument(
  request: DocumentoRequestUpdate,
  shouldUseBff: boolean,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkActionDefault {
  return async () => {
    const { fail, response } = !shouldUseBff
      ? await documentosAPI.update(request)
      : await documentosAPI.updateBff(request);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (response?.status === 200) {
      successCallback && successCallback();
    }
  };
}

export function assembleiaAssessorActionsRemoveDocument(
  idEvento: string,
  idDocumento: number,
  shouldUseBff: boolean,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkActionDefault {
  return async () => {
    const { fail, response } = !shouldUseBff
      ? await documentosAPI.remove(String(idEvento), idDocumento)
      : await documentosAPI.removeBff(String(idEvento), Number(idDocumento));
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (response?.status === 200) {
      successCallback && successCallback();
    }
  };
}

export function assembleiaAssessorActionsUploadDocument(
  data: DocumentoRequestUpload,
  shouldUseBff: boolean,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkActionDefault {
  return async () => {
    const { fail, response } = !shouldUseBff
      ? await documentosAPI.upload(data)
      : await documentosAPI.uploadBff(data);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (response?.status === 200) {
      successCallback && successCallback();
    }
  };
}

export const assembleiasAssessorActionsLoadContas = (
  eventoId: number,
  cpfCnpj: string,
  callbackSuccess?: (contas: IAssembleiaAssessorLoadContas[]) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
      payload: true,
    });
    new Promise(
      (
        resolve: (contas: IAssembleiaAssessorLoadContas[]) => void,
        reject: (error: AxiosError<ErrorAPI>) => void
      ) => {
        toRequest(
          ApiService.get,
          [
            `${getAssembleiasAssessorEndpoint(
              '1'
            )}evento/${eventoId}/convocado/${cpfCnpj}`,
          ],
          'assembleiaAssessorLaodContas'
        ).then(
          (resp) => {
            const data: IAssembleiaAssessorLoadContas[] =
              resp.data as IAssembleiaAssessorLoadContas[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
              payload: false,
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
              payload: false,
            });
            reject(error);
          }
        );
      }
    ).then(
      (contas) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(contas);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssessorActionsLoadDuvidas = (
  idEvento: number,
  filtros?: MensagensFiltros,
  callbackSuccess?: (duvidas: PaginationDuvidas) => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async (dispatch) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS,
      payload: true,
    });
    const { fail, data } = await duvidasApi.listar(idEvento, filtros);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS,
        payload: data,
      });
      callbackSuccess && callbackSuccess(data);
    }
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS,
      payload: false,
    });
  };
};

export function assembleiaAssessorActionsSaveVideo(
  request: VideoRequest,
  shouldUseBff: boolean,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkActionDefault {
  return async () => {
    const { fail, response } = !shouldUseBff
      ? await videoAPI.registrar(request)
      : await videoAPI.saveBff(request);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (response?.status === 200) {
      successCallback && successCallback();
    }
  };
}

export function assembleiaAssessorActionsDeleteVideo(
  idEvento: string,
  videoId: number,
  shouldUseBff: boolean,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkActionDefault {
  return async () => {
    const { fail, response } = !shouldUseBff
      ? await videoAPI.apagar(Number(idEvento), videoId)
      : await videoAPI.deleteBff(String(idEvento), videoId);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (response?.status === 200) {
      successCallback && successCallback();
    }
  };
}

export function assembleiaAssessorActionsDeleteVideoBatch(
  eventId: number,
  data: BatchVideoRequest,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkActionDefault {
  return async () => {
    const { fail, response } = await videoAPI.deleteBatchBff(eventId, data);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (response?.status === 200) {
      successCallback && successCallback();
    }
  };
}

export function assembleiaAssessorActionsEditVideo(
  data: VideoRequest,
  shouldUseBff: boolean,
  successCallback?: () => void,
  errorCallback?: (error: ErrorAPI) => void
): ThunkActionDefault {
  return async () => {
    const { fail, response } = !shouldUseBff
      ? await videoAPI.editar(data)
      : await videoAPI.editBff(data);
    if (fail) {
      errorCallback && errorCallback(fail);
    }
    if (response?.status === 200) {
      successCallback && successCallback();
    }
  };
}

export const assembleiasAssessorActionsResponderDuvida = (
  idDuvida: number,
  resposta: string,
  flgPublica: boolean,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async (dispatch, getState) => {
    const { fail, data } = await duvidasApi.responder({
      idDuvida,
      resposta,
      flgPublica,
    });
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      const _duvidas = Object.assign(
        {},
        getState().assembleiasAssessor.duvidas
      );
      _duvidas.elements.forEach((conversa) => {
        const found = conversa.duvidas.findIndex(
          (duvida) => duvida.idDuvidaFrequente === idDuvida
        );
        if (found > -1) {
          conversa.duvidas[found] = Object.assign(
            {},
            conversa.duvidas[found],
            data
          );
        }
      });
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS,
        payload: _duvidas,
      });
      callbackSuccess && callbackSuccess();
    }
  };
};

export const assembleiasAssessorActionsVisibilidadeDuvida = (
  idDuvida: number,
  flgPublica: boolean,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async (dispatch, getState) => {
    const { fail, response } = await duvidasApi.alterarStatus({
      idDuvida,
      flgPublica,
    });
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (response?.status === 200) {
      const _duvidas = Object.assign(
        {},
        getState().assembleiasAssessor.duvidas
      );
      _duvidas.elements.forEach((conversa) => {
        const found = conversa.duvidas.findIndex(
          (duvida) => duvida.idDuvidaFrequente === idDuvida
        );
        if (found > -1) {
          conversa.duvidas[found] = Object.assign({}, conversa.duvidas[found], {
            flgPublica,
          });
        }
      });
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS,
        payload: _duvidas,
      });
      callbackSuccess && callbackSuccess();
    }
  };
};

export const assembleiasAssessorRegistrarPresenca = (
  registrarPresencaRequest: IAssembleiasAssessoresRegistrarPresenca,
  callbackSuccess?: () => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA,
      payload: true,
    });
    new Promise((resolve, reject) => {
      toRequest(
        ApiService.post,
        [
          `${getAssembleiasAssessorEndpoint('1')}presenca/`,
          registrarPresencaRequest,
        ],
        'registrarPresenca'
      ).then(
        () => {
          resolve(undefined);
        },
        (error: AxiosError<ErrorAPI>) => {
          dispatch({
            type: ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA,
            payload: false,
          });
          reject(error);
        }
      );
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_REGISTRANDO_PRESENCA,
          payload: false,
        });
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssessorPautaResposta = (
  votoPresencialRequest: IRequestPautasRespostas,
  callbackSuccess?: () => void,
  callbackError?: (error: AxiosError) => void
) => {
  return () => {
    new Promise((resolve, reject) => {
      toRequest(
        ApiService.post,
        [
          `${getAssembleiasAssessorEndpoint('1')}voto-presencial/`,
          {
            codigoAgencia: votoPresencialRequest.codigoAgencia,
            idPauta: votoPresencialRequest.idPauta,
            itensPauta: votoPresencialRequest.itensPauta,
            numeroNucleo: votoPresencialRequest.numeroNucleo,
            flagDeclaracaoSemVotos:
              votoPresencialRequest.flagDeclaracaoSemVotos,
          },
        ],
        'encerrar'
      ).then(
        () => {
          resolve(undefined);
        },
        (error: AxiosError) => {
          reject(error);
        }
      );
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssessorCadastrarPauta =
  (
    pautaRequest: ICadastrarPautaRequest | ICadastrarPautaRequest2,
    registering: boolean,
    callbackSuccess?: (resp: AxiosResponse<PautaEvento>) => void,
    callbackError?: (error: AxiosError<ErrorAPI>) => void,
    callbackFinally?: () => void
  ) =>
  (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA,
      payload: true,
    });
    return toRequest<PautaEvento>(
      ApiService.post,
      !registering
        ? [`${getAssembleiasAssessorEndpoint('1')}pauta/`, pautaRequest]
        : [`${getAssembleiasAssessorBffEndpoint('1')}agenda/`, pautaRequest],
      'cadastroPauta'
    )
      .then((resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      })
      .catch((error: AxiosError<ErrorAPI>) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      })
      .finally(() => {
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_CADASTRANDO_PAUTA,
          payload: false,
        });
        if (typeof callbackFinally === 'function') {
          callbackFinally();
        }
      });
  };

export const assembleiasAssessorDeletarPauta = (
  idEvento: number,
  idPauta: number,
  flgCienteDelecao: boolean,
  callbackSuccess?: () => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA,
      payload: true,
    });
    new Promise((resolve, reject) => {
      toRequest(
        ApiService.delete,
        [
          `${getAssembleiasAssessorEndpoint(
            '1'
          )}pauta/${idEvento}/${idPauta}/${flgCienteDelecao}`,
        ],
        'deletarPauta'
      ).then(
        () => {
          resolve(undefined);
        },
        (error: AxiosError<ErrorAPI>) => {
          dispatch({
            type: ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA,
            payload: false,
          });
          reject(error);
        }
      );
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_DELETANDO_PAUTA,
          payload: false,
        });
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const deleteAgenda = (request: DeleteProps) => {
  const url = `${getAssembleiasAssessorBffEndpoint()}agenda/delete-many/true`;
  return toRequest<any>(ApiService.delete, [url, request], 'delete');
};

export const loadDefaultStaves = () => {
  const url = `${getAssembleiasAssessorBffEndpoint()}agenda/default`;
  return toRequest<any>(ApiService.get, [url], 'delete');
};

export const assembleiasAssessorLoadVotosInconsistentes = (
  idEvento: number,
  callbackSuccess?: (all: IVotosInconsistentes[]) => void,
  callbackError?: (error: AxiosError) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_VOTOS_INCONSISTENTES,
      payload: true,
    });
    new Promise(
      (
        resolve: (all: IVotosInconsistentes[]) => void,
        reject: (error: AxiosError) => void
      ) => {
        toRequest(
          ApiService.get,
          [
            `${getAssembleiasAssessorEndpoint(
              '1'
            )}evento/${idEvento}/inconsistencias-hibrido`,
          ],
          'assembleiasAssessorLoadVotosInconsistentes'
        ).then(
          (resp) => {
            const data: IVotosInconsistentes[] =
              resp.data as IVotosInconsistentes[];
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOAD_VOTOS_INCONSISTENTES,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_VOTOS_INCONSISTENTES,
              payload: false,
            });
            resolve(data);
          },
          (error: AxiosError) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_VOTOS_INCONSISTENTES,
              payload: false,
            });
            reject(error);
          }
        );
      }
    ).then(
      (all) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(all);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssessorActionsLoadAgenciasNucleosSemVoto = (
  idPauta: number,
  callbackSuccess?: (
    response: IAssembleiaAssessorAgenciaNucleosSemVoto[]
  ) => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    dispatch({
      type: ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_NUCLEOS_SEM_VOTO,
      payload: true,
    });
    new Promise(
      (
        resolve: (response: IAssembleiaAssessorAgenciaNucleosSemVoto[]) => void,
        reject: (error: AxiosError<ErrorAPI>) => void
      ) => {
        toRequest(
          ApiService.get,
          [`${getAssembleiasAssessorEndpoint('1')}voto/${idPauta}`],
          ''
        ).then(
          (resp) => {
            const data: IAssembleiaAssessorAgenciaNucleosSemVoto[] = (
              resp.data as any[]
            ).map((it) => {
              return {
                ...it,
                idPauta,
              };
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADED_AGENCIAS_NUCLEOS_SEM_VOTO,
              payload: data,
            });
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_NUCLEOS_SEM_VOTO,
              payload: false,
            });
            resolve(data);
          },
          (error: AxiosError<ErrorAPI>) => {
            dispatch({
              type: ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_NUCLEOS_SEM_VOTO,
              payload: false,
            });
            reject(error);
          }
        );
      }
    ).then(
      (response: IAssembleiaAssessorAgenciaNucleosSemVoto[]) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(response);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssessorActionsRegistraVotoAgenciasNucleosSemVoto = (
  codigoAgencia: string,
  numeroNucleo: string,
  idItemPauta: number,
  callbackSuccess?: () => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return () => {
    const urlParams: URLSearchParams = new URLSearchParams();
    urlParams.append('codigoAgencia', codigoAgencia);
    urlParams.append('numeroNucleo', numeroNucleo);
    urlParams.append('idItemPauta', idItemPauta.toString());
    new Promise((resolve, reject) => {
      toRequest(
        ApiService.post,
        [
          `${getAssembleiasAssessorEndpoint(
            '1'
          )}voto/agencia-nucleo?${urlParams.toString()}`,
        ],
        ''
      ).then(
        () => {
          resolve(undefined);
        },
        (error: AxiosError<ErrorAPI>) => {
          reject(error);
        }
      );
    }).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const assembleiasAssessorEdit = (
  evento: AssembleiaAssessorDadosInformativos,
  callbackSuccess?: () => void,
  callbackError?: (error: AxiosError<ErrorAPI>) => void
) => {
  return (dispatch: Dispatch<AssembleiasAssessorActionTypes>) => {
    const eventoDTO = {
      idEvento: evento.idEvento,
      titulo: evento.nome,
      descricao: evento.descricao,
      urlTransmissao: evento.urlTransmissao,
      dataEvento: moment(
        evento.dataEvento + ' ' + evento.horarioEvento,
        'DD/MM/YYYY HH:mm'
      ).format('YYYY-MM-DDTHH:mm:ss'),
      dataFimEvento:
        evento.dataFimEvento && evento.dataFimEvento !== 'Invalid date'
          ? moment(
              evento.dataFimEvento + ' ' + evento.horarioFimEvento,
              'DD/MM/YYYY HH:mm'
            ).format('YYYY-MM-DDTHH:mm:ss')
          : moment(
              evento.dataEvento + ' ' + evento.horarioEvento,
              'DD/MM/YYYY HH:mm'
            ).format('YYYY-MM-DDTHH:mm:ss'),
      dataEventoOnline:
        evento.dataEventoOnline && evento.dataEventoOnline !== 'Invalid date'
          ? moment(
              evento.dataEventoOnline + ' ' + evento.horarioEventoOnline,
              'DD/MM/YYYY HH:mm'
            ).format('YYYY-MM-DDTHH:mm:ss')
          : undefined,
      // : moment(
      //     evento.dataEvento + ' ' + evento.horarioEvento,
      //     'DD/MM/YYYY HH:mm'
      //   ).format('YYYY-MM-DDTHH:mm:ss'),
      dataFimEventoOnline:
        evento.dataFimEventoOnline &&
        evento.dataFimEventoOnline !== 'Invalid date'
          ? moment(
              evento.dataFimEventoOnline + ' ' + evento.horarioFimEventoOnline,
              'DD/MM/YYYY HH:mm'
            ).format('YYYY-MM-DDTHH:mm:ss')
          : undefined,
      // : moment(
      //     evento.dataFimEvento + ' ' + evento.horarioFimEvento,
      //     'DD/MM/YYYY HH:mm'
      //   ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    toRequest(
      ApiService.put,
      [`${getAssembleiasAssessorEndpoint('1')}evento/edit`, eventoDTO],
      'putAssembleiaAssessorEdit'
    )
      .then(() => {
        dispatch({
          type: ASSEMBLEIAS_ASSESSOR_EDITED,
        });
        callbackSuccess?.();
      })
      .catch((error: AxiosError<ErrorAPI>) => {
        callbackError?.(error);
      });
  };
};

export const assembleiasAssessorActionsCheckQuorum = (
  idEvento: number,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async (dispatch) => {
    const { fail, data } = await quorumApi.existe(idEvento);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_UPDATE_QUORUM,
        payload: data.existeQuorum,
      });
      callbackSuccess && callbackSuccess();
    }
  };
};

export const assembleiasAssessorActionsRegistraQuorum = (
  idEvento: number,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async (dispatch) => {
    const { fail, response } = await quorumApi.startVoting(idEvento);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (response && response.status === 200) {
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_UPDATE_QUORUM,
        payload: true,
      });
      callbackSuccess && callbackSuccess();
    }
  };
};

export const assembleiasAssessorActionsStartVoting = (
  idEvento: number,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async (dispatch) => {
    const { fail, response } = await quorumApi.startVoting(idEvento);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (response && response.status === 200) {
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_UPDATE_VOTATION,
        payload: true,
      });
      callbackSuccess && callbackSuccess();
    }
  };
};

export const assembleiasAssessorActionsLiberarResultadoPresencial = (
  idEvento: number,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async (dispatch) => {
    const { fail, response } = await quorumApi.liberarPresencial(idEvento);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (response && response.status === 200) {
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_UPDATE_QUORUM,
        payload: true,
      });
      callbackSuccess && callbackSuccess();
    }
  };
};

export const assembleiasAssessorActionsLiberarResultadoPresencialPauta = (
  idEvento: number,
  idPauta: number,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async (dispatch) => {
    const { fail, response } = await quorumApi.liberarPresencialPauta(
      idEvento,
      idPauta
    );
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (response && response.status === 200) {
      dispatch({
        type: ASSEMBLEIAS_ASSESSOR_UPDATE_QUORUM,
        payload: true,
      });
      callbackSuccess && callbackSuccess();
    }
  };
};

export const assembleiasAssessorActionsAtualizarPresencas = (
  idEvento: number,
  callbackSuccess?: (data: PresencasResponse) => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async () => {
    const { fail, data } = await eventoApi.atualizarPresencas(idEvento);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
  };
};

export const assembleiasAssessorActionsUsuarioCooperativas = (
  callbackSuccess?: (cooperativas: CooperativasUsuarioResponse) => void,
  callbackErrror?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async () => {
    const { fail, data } = await usuarioApi.cooperativas();
    if (fail) {
      callbackErrror && callbackErrror(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
  };
};

export const assembleiasAssessorActionsListagemLogins = (
  request: Partial<ListagemLoginsRequest>,
  page?: number,
  size?: number,
  callbackSuccess?: (listagem: ListagemLoginsResponse) => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async () => {
    const { fail, data } = await usuarioApi.listagemLogins(request, page, size);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      callbackSuccess && callbackSuccess(data);
    }
  };
};

export const assembleiasAssessorActionsListagemLoginsRelatorio = (
  request: Partial<ListagemLoginsRequest>,
  page?: number,
  size?: number,
  callbackSuccess?: () => void,
  callbackError?: (error: ErrorAPI) => void
): ThunkActionDefault => {
  return async () => {
    const { fail, data } = await relatorioApi.logins(request, page, size);
    if (fail) {
      callbackError && callbackError(fail);
    }
    if (data) {
      const dateFrom = request.iniCreatedAt!.split('T')[0];
      const dateTo = request.fimCreatedAt!.split('T')[0];
      const fileName = `RelatorioLogins_${dateFrom}_${dateTo}.csv`;
      trigger(fileName, data);
      callbackSuccess && callbackSuccess();
    }
  };
};
